if (!customElements.get('decolab-product-demo')) {
  customElements.define('decolab-product-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const trigger = this.querySelector('.decolab-demo__trigger');
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      const close = this.querySelector('.decolab-demo__close');
      trigger.addEventListener('click', () => {
        if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
        dialog.showModal();
        video.play().catch(() => { /* Native play remains available. */ });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => { video.pause(); trigger.focus(); });
    }
  });
}
